<div
  ngbDropdown
  #dropDownPicker
  class="d-inline-block w-100"
  [container]="'body'"
  [style]="disabled ? 'pointer-events: none;' : ''"
  [dropdownClass]="formatedClass">
  <div [ngClass]="{ 'input-group': true, 'position-relative': showInfiniteIcon }">
    <input
      class="form-control form-control-sm"
      name="inputDate"
      readonly
      [(ngModel)]="dateTime"
      ngbDropdownToggle />
    <div class="input-group-text" *ngIf="allowNull">
      <button class="btn btn-link" (click)="resetValue()" type="button">
        {{ '::Clear' | abpLocalization }}
      </button>
    </div>
    <div
      *ngIf="showInfiniteIcon"
      class="position-absolute end-0 top-50 translate-middle-y pe-2"
      style="cursor: pointer"
      (click)="setInfiniteDate()">
      <i style="color: #0078d4" class="bi bi-infinity"></i>
    </div>
  </div>
  <div ngbDropdownMenu aria-labelledby="inputDate">
    <div class="row main {{ hideTime ? 'pb-3' : '' }}">
      <div class="col-12">
        <div class="row m-1 {{ isRTL ? 'rtl-datepicker' : '' }}">
          <ngb-datepicker
            #dtp
            id="dtp"
            [maxDate]="formatedMaxDate"
            [minDate]="formatedMinDate"
            (dateSelect)="onDateSelect($event)"
            name="dtp"
            class="picker"
            [(ngModel)]="date"></ngb-datepicker>
        </div>
        <div class="row justify-content-center pt-3" *ngIf="!hideTime">
          <ngb-timepicker
            (change)="onTimeChange($event)"
            name="time"
            [(ngModel)]="ngbTime"
            [spinners]="false"></ngb-timepicker>
        </div>
        <div class="row" [hidden]="!useShortcuts" dir="ltr">
          <div
            class="col mt-3"
            style="text-align: center; padding-left: 0px !important"
            [style]="disabled ? 'pointer-events: none;' : ''">
            <button
              type="button"
              class="ca-btn ca-btn-link ca-btn-link-sm p-0"
              (click)="onShortcutClick(0)">
              <i class="bi-dot"></i>
              <span #shortcutSpan [attr.shortcut]="0">
                {{ 'DateTimeRangePicker::Today' | abpLocalization }}
              </span>
            </button>
            <button
              type="button"
              class="ca-btn ca-btn-link ca-btn-link-sm p-0"
              (click)="onShortcutClick(-7)">
              <i class="bi-dot"></i>
              <span #shortcutSpan [attr.shortcut]="-7">
                {{ 'DateTimeRangePicker::Last7Days' | abpLocalization }}
              </span>
            </button>
            <button
              type="button"
              class="ca-btn ca-btn-link ca-btn-link-sm p-0"
              (click)="onShortcutClick(-30)">
              <i class="bi-dot"></i>
              <span #shortcutSpan [attr.shortcut]="-30">
                {{ 'DateTimeRangePicker::Last30Days' | abpLocalization }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
